// Stateless request/response helpers the embed proxy and authorize route share.

// Proxy decrypts the URL token and forwards identity on these request headers so Server Components
// (layout has no searchParams) and SSR reads can resolve vid/session without cookies.
export const EMBED_SESSION_HEADER = 'x-embed-session';
export const EMBED_VID_HEADER = 'x-embed-vid';

// Partner branding (name/logo) forwarded the same way — read via getEmbedPartnerBrandingSsr.
export const EMBED_PARTNER_LOGO_HEADER = 'x-embed-partner-logo';
export const EMBED_PARTNER_NAME_HEADER = 'x-embed-partner-name';

// Packed JSON experience knobs from the token (hostContactFormLocation today; more keys later).
// Read via getEmbedCustomizationsSsr. Branding stays on its own headers — not in this object.
export const EMBED_CUSTOMIZATIONS_HEADER = 'x-embed-customizations';

// Ambient client identity (getApiHeaders). Persist uses props via injected strategy — not these keys
// (mount-order races). Seed also keeps identity in memory; Safari can throw on storage in iframes.
export const EMBED_SESSION_STORAGE_KEY = 'embed-session-id';
export const EMBED_VID_STORAGE_KEY = 'embed-vid';

export const parseEmbedPartnerId = (pathname: string): string | undefined => pathname.match(/^\/embed\/([^/]+)/)?.[1];

const EMBED_IDENTITY_HEADERS = [
  EMBED_VID_HEADER,
  EMBED_SESSION_HEADER,
  EMBED_PARTNER_NAME_HEADER,
  EMBED_PARTNER_LOGO_HEADER,
  EMBED_CUSTOMIZATIONS_HEADER,
];

// getCurrentIdentitySsr trusts these over marketplace vid/session cookies, so a
// request outside /embed/* must never be able to supply them itself — only handleEmbedProxy (which
// overwrites them with token-derived values) is allowed to set them. Strip on every other path.
export const stripEmbedIdentityHeaders = (headers: Headers): void => {
  EMBED_IDENTITY_HEADERS.forEach((header) => headers.delete(header));
};

export const frameAncestorsCsp = (allowedOrigins: string[]) => `frame-ancestors ${allowedOrigins.join(' ')}`;

// The identity token lives in the URL, so lock down the channels it can leak through: strict-origin
// keeps the token's query string out of the Referer sent to third-party subresources (Maps, Segment)
// while still sending the bare origin those APIs need; no-store prevents CDNs/proxies from caching a
// URL that carries a bearer token.
export const applyEmbedSecurityHeaders = (headers: Headers): void => {
  headers.set('Referrer-Policy', 'strict-origin');
  headers.set('Cache-Control', 'no-store');
};
